// extracted by mini-css-extract-plugin
module.exports = {"root":"_e7840163","header":"_1cc4924d","footer":"_e0c34e15","body":"_06eb924f"};